import React from 'react'

import { Box } from '@hermes/web-components'

import BaseModal from '@components/BaseModal'
import useTranslateMessage from '@hooks/useTranslateMessage'

import { TextContent, BulletTitle, ModalButton } from './RecommendedSellerInfoModal.styles'

interface Props {
  isOpen: boolean
  onClose: () => void
}
const RecommendedSellerInfoModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslateMessage()

  return (
    <BaseModal
      isOpen={isOpen}
      width={423}
      onClose={onClose}
      title={t({ id: 'seller_ranking.how_do_we_rank_title', defaultMessage: 'How do we rank sellers?' })}
    >
      <Box padding="12px 16px 12px 16px" display="flex" flexDirection="column">
        <TextContent>
          {t({
            id: 'seller_ranking.preamble',
            defaultMessage:
              'The highest ranked sellers are the most likely to give you a good shopping experience, based on these criteria:'
          })}
          <ul>
            <li>
              <BulletTitle>
                {t({ id: 'seller_ranking.bullet1_title', defaultMessage: 'Competitive pricing' })}
              </BulletTitle>
              {t({
                id: 'seller_ranking.bullet1_text',
                // prettier-ignore
                defaultMessage:
                  'The seller\'s rating is based on the average of the ratings they have received from their customers.'
              })}
            </li>
            <li>
              <BulletTitle>
                {t({ id: 'seller_ranking.bullet2_title', defaultMessage: 'Quick to approve requests' })}
              </BulletTitle>
              {t({
                id: 'seller_ranking.bullet2_text',
                defaultMessage:
                  'The highest ranked sellers are the most frequently active on Bookis who approve and fulfill orders fast'
              })}
            </li>
            <li>
              <BulletTitle>
                {t({ id: 'seller_ranking.bullet3_title', defaultMessage: 'Relevant assortment' })}
              </BulletTitle>
              {t({
                id: 'seller_ranking.bullet3_text',
                defaultMessage:
                  'Top sellers are likely to have other books from the same author or genre in their assortment, in case you might be looking for other books as well. Remember, there is no extra shipping cost if you buy more books from the same seller!'
              })}
            </li>
          </ul>
        </TextContent>
      </Box>
      <ModalButton onClick={onClose}>{t({ id: 'common.ok', defaultMessage: 'OK' })}</ModalButton>
    </BaseModal>
  )
}

export default RecommendedSellerInfoModal
